import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import OriginalGamesFooter from './OriginalGamesFooter';
import StandardGamesFooter from './StandardGamesFooter';
import isWebComponentGame from '@/shared/utils/isWebComponentGame';

const GameFooter: FC = () => {
  const { game } = useGameContext();

  if (isWebComponentGame(game?.handle)) {
    return <OriginalGamesFooter />;
  }

  return <StandardGamesFooter game={game} />;
};

export default GameFooter;
